export default __webpack_public_path__ + "static/media/4.fd48b91b.webp";